export default __webpack_public_path__ + "static/blog-0-02-5452f8f440123fa0d9d92ef5580485b5.png";